import { SYSTEM_MODULES } from "constants/modules"
import { normalizePlanFeatureKey } from "constants/planPermissionMap"

const MODULE_BY_ID = new Map(SYSTEM_MODULES.map(m => [m.id, m]))

const LEGACY_FEATURE_KEYS = new Set([
  "branches",
  "branch",
  "locations",
  "admin_users",
  "admin_user",
  "api_rate_limit",
])

/** @param {number} value */
export const formatPlanCap = (value, t) => {
  const n = Number(value)
  if (!n || n <= 0) {
    return t("Unlimited")
  }
  return String(n)
}

/**
 * @param {object} plan
 * @returns {{ label: string, hint?: string }[]}
 */
export const getPlanIncludedFeatures = (plan, t) => {
  const items = []
  const seen = new Set()

  for (const raw of plan?.features || []) {
    const key = normalizePlanFeatureKey(
      raw?.name || raw?.id || raw?.moduleId || raw?.code || ""
    )
    if (!key || LEGACY_FEATURE_KEYS.has(key)) {
      continue
    }

    if (key === "integrations") {
      if (!seen.has("integrations")) {
        seen.add("integrations")
        items.push({
          label: t("Integrations"),
          hint: t("Third-party integrations"),
        })
      }
      continue
    }

    const mod = MODULE_BY_ID.get(key)
    if (mod) {
      if (!seen.has(key)) {
        seen.add(key)
        items.push({
          label: t(mod.label),
          hint: mod.description ? t(mod.description) : undefined,
        })
      }
      continue
    }

    const label = raw?.name || key
    const dedupe = String(label).toLowerCase()
    if (seen.has(dedupe)) continue
    seen.add(dedupe)

    let hint
    const limit = raw?.limit
    if (
      limit !== undefined &&
      limit !== null &&
      limit !== "enabled" &&
      limit !== "default"
    ) {
      hint =
        limit === "Unlimited" || limit === 0
          ? t("Unlimited")
          : t("Limit: {{limit}}", { limit: String(limit) })
    }

    items.push({ label: typeof label === "string" ? label : String(label), hint })
  }

  return items
}
